define("shared/utils/search/compute-search-results", ["exports", "@ember/array", "@ember/utils", "lodash", "shared/utils/search"], function (_exports, _array, _utils, _lodash, _search) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/array",0,"@ember/utils",0,"lodash",0,"shared/utils/search"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class computeSearchResults
   * @extends Utils
   */
  /**
   *
   * @method computeSearchResults
   * @param {Array} searchableObjs Array of objects to match by query text
   * @param {String} queryText string of text to extract search terms from
   * @param {String} searchableProperty property on searchableObjs to search for matching results
   *
   * @return {Number} Value of matching for keyword within query
   */
  const computeSearchResults = function (searchableObjs, queryText) {
    let searchableProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'keyword';
    const searchedWords = (0, _search.determineSearchedWords)(queryText);
    return (0, _lodash.flattenDeep)(searchableObjs.map(obj => searchedWords.reduce((matches, searchWord) => {
      let keywordIncludesQuery;
      let queryIncludesKeyword;
      let searchableTerm = obj[searchableProperty];
      const regexString = searchableProperty === 'title' ? `${searchWord}` : `^${searchWord}`;

      // Note: handle query being substring of keyword
      const keywordRegEx = new RegExp(regexString, 'i');
      if ((0, _array.isArray)(searchableTerm)) {
        searchableTerm = searchableTerm.find(term => keywordRegEx.test(term));
        keywordIncludesQuery = (0, _utils.isPresent)(searchableTerm);
      } else {
        queryIncludesKeyword = keywordRegEx.test(searchableTerm);
        if (!queryIncludesKeyword && searchableTerm) {
          // Note: handle query including keyword as substring
          const queryRegEx = new RegExp(`^${searchableTerm}`, 'i');
          keywordIncludesQuery = queryRegEx.test(searchWord);
        }
      }
      if (keywordIncludesQuery || queryIncludesKeyword) {
        return [...matches, Object.assign({}, obj, {
          matchingKeyword: searchableTerm,
          matchRatio: searchableTerm ? (0, _search.calculateMatchRatio)(searchWord, searchableTerm) : 0.1
        })];
      }
      return matches;
    }, [])));
  };
  var _default = _exports.default = computeSearchResults;
});